// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
exports.push([module.id, ".eos-chart__treeview__section[data-v-4b657ac3]:hover{background-color:#eaeaea}.eos-chart__treeview__node[data-v-4b657ac3]:not(.disabled){cursor:move}[data-v-4b657ac3] .eos-chart__treeview__person-name{font-size:10px}", ""]);
// Exports
module.exports = exports;
